import { createPricingConfigs } from "@shapr3d/frontend-lib";

// Currently identical but later in this file we could modify the mapping if needed
export const getWebAppPricingConfigs = createPricingConfigs;
